import Globe from 'assets/svg/icons/globe';
import { Menu } from 'components/atoms/Menu';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AvailableLanguages } from 'types/users.types';
import { ChevronDownIconOutline, ChevronUpIconOutline } from 'utils/icons';

const languageLabels: Record<AvailableLanguages, string> = {
  [AvailableLanguages.en]: 'English',
  [AvailableLanguages.de]: 'Deutsch',
  [AvailableLanguages.fr]: 'Français',
  [AvailableLanguages.nl]: 'Nederlands',
};

const languageOrder: AvailableLanguages[] = [
  AvailableLanguages.en,
  AvailableLanguages.de,
  AvailableLanguages.fr,
  AvailableLanguages.nl,
];

type ExpertLanguageDropdownProps = {
  className?: string;
  onChange?: (lang: AvailableLanguages) => void;
};

const ExpertLanguageDropdown: FC<ExpertLanguageDropdownProps> = ({
  className,
  onChange,
}) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language as AvailableLanguages;

  const handleChange = (lang: AvailableLanguages) => {
    i18n.changeLanguage(lang);
    i18n.services?.languageDetector?.cacheUserLanguage?.(lang);
    try {
      localStorage.setItem('i18nextLng', lang);
      localStorage.setItem('preferredExpertLanguage', lang);
    } catch {
      // ignore localStorage errors
    }
    onChange?.(lang);
  };

  return (
    <Menu
      trigger={({ open }) => (
        <div
          className={`text-primary-500 font-semibold flex items-center gap-1.5 rounded-lg border border-primary-100 px-2.5 py-2 ${
            className ?? ''
          }`}
        >
          <Globe className="w-5" />
          <span className="mx-0.5">{currentLang.toUpperCase()}</span>
          {open ? (
            <ChevronUpIconOutline
              className="w-3 relative top-px"
              strokeWidth="3"
            />
          ) : (
            <ChevronDownIconOutline
              className="w-3 relative top-px"
              strokeWidth="3"
            />
          )}
        </div>
      )}
      position="right"
      contentWrapperClassName="!w-auto"
    >
      <Menu.Group>
        {languageOrder.map((lang) => (
          <Menu.Button key={lang} onClick={() => handleChange(lang)}>
            {languageLabels[lang]}
          </Menu.Button>
        ))}
      </Menu.Group>
    </Menu>
  );
};

export default ExpertLanguageDropdown;
